export const BASE_URL = 'https://api.cornello.net';

export const VERSION = '1.14.0';
// export const VERSION = '3.0.0';